exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.wz_viewListAgents{height: 100% !important;\n}\n.ContentListeAgents, .ContentListeAgentsClassic {height: calc(100% - 48px) !important; overflow-y: auto;\n}\n.ContentListeAgentsClassic .wzSelectedAgent{background-color: rgba(0,0,0,0.1)\n}\n.itemsListeAgent{cursor: pointer;\n}\n.itemsListeAgent:hover{background-color: rgba(200,200,200,0.1)\n}\n.listeChatsAgents .v-list__tile__content {margin-left: 8px\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/watcheebox/WzListAgents.vue
// module id = o8vE
// module chunks = 1